import { IState } from '../../../store';

export function selectCallTrackingProvider(state: IState) {
  return state.offerData.offer.callTrackingProvider;
}
